import { CostsAndCharges } from 'components/quote/costsAndCharges/CostsAndCharges';
import type { CostAndCharge } from 'models/streaming/costsAndCharges';
import { FC } from 'react';

import { RegulatoryComponentWrapper } from './Components';

interface CostsAndChargesRegulatoryComponentProps {
  isCostsAndChargesRequired: boolean;
  costsAndChargesWithNotional: CostAndCharge[] | undefined;
  isLoading: boolean;
}

export const CostsAndChargesRegulatoryComponent: FC<CostsAndChargesRegulatoryComponentProps> = ({
  isCostsAndChargesRequired,
  costsAndChargesWithNotional,
  isLoading,
}) => {
  if (!isCostsAndChargesRequired) {
    return null;
  }
  return (
    <RegulatoryComponentWrapper
      componentId="costs-and-charges-accordion"
      title="costAndCharge.title"
      isLoading={isLoading}
      isInError={false}
    >
      {costsAndChargesWithNotional && <CostsAndCharges costsAndCharges={costsAndChargesWithNotional} />}
    </RegulatoryComponentWrapper>
  );
};

CostsAndChargesRegulatoryComponent.displayName = 'CostsAndChargesRegulatoryComponent';
